module.exports = __webpack_public_path__ + "Frame392-9b664c09.webp";